// src/components/NotificationHandler.js
import { useEffect } from "react";
import { requestForToken, listenForMessages } from "./firebase";
import toast from "react-hot-toast";
import { useNotificationsUpdater } from "./updateNotifications";

function NotificationHandler() {

  const { update } = useNotificationsUpdater();

  useEffect(() => {
    requestForToken();
    const unsubscribe = listenForMessages((payload) => {
      update();
      toast.custom((t) => (
        <div className={`${ t.visible ? "animate-enter" : "animate-leave"} max-w-sm w-full max-h-14 bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}>
          <div className="flex-1 w-0 px-4 py-2">
            <div className="flex items-center justify-between gap-4">
              <span className="text-2xl">🔔</span>        
              <div className="ml-1 flex justify-between items-center flex-1">
                <p className="text-md font-medium text-gray-900">
                  {payload.notification?.title || "New Notification"}
                </p>
                {/* <p className="mt-1 text-sm text-gray-500">
                  {payload.notification?.body || "You’ve got an update."}
                </p> */}
                <p className="mt-1 text-sm text-left text-gray-400">
                  {new Date().toLocaleTimeString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      ));
    });

    // Cleanup when component unmounts
    return () => unsubscribe();
  }, []);

  return null;
}
export default NotificationHandler;
